import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
    padding-bottom: 50px;
    transition: 0.2s;
    @media screen and (max-width: 1140px){
        padding: 0 20px 50px;
    }
`
export const List = styled.ul`
    max-width: 1140px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap:80px;
    overflow: hidden;
    padding-top:40px;
`
export const ListItem = styled.li`
    width: 100%;
    display: flex;
    gap: 30px;
    position: relative;
    &::before{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: #ff7f00;
        top: -40px;
        right: 50%;
        transform: translateX(50%);
    }
    transition: 0.2s;
    @media screen and (max-width: 767px){
        flex-direction: column;
        
    }
`
export const InfoWrap = styled.div`
    width: calc((100% - 30px)/2);
    display: flex;
    flex-direction: column;
    gap: 20px;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        width: 100%;
    }
`
export const ItemTitle = styled.h3`
    font-size: 25px;
    text-align: left;
    color: #00a0e7;
    text-transform: uppercase;
    letter-spacing: 5px;
`
export const ItemText = styled.p`
    font-size: 17px;
    color: #777777;
    line-height: 1.66em;
`
